<script lang="ts">
    import { get_current_component, onMount } from 'svelte/internal'
    import Fa from 'svelte-fa'
    import { faEdit } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import type { User } from '../../modules/usersApi/users/user'
    import { NotesRepository } from '../../modules/eventsApi/notes/notes.repository'
    import { NotesService } from '../../modules/eventsApi/notes/notes.service'
    import { CompaniesRepository } from '../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../modules/usersApi/companies/companies.service'
    import { Note } from '../../modules/eventsApi/notes/note'
    import type { CreateNoteDto } from '../../modules/eventsApi/notes/create-note.dto'
    import { Store } from '../../modules/infra/store.service'
    import Zframe from '../_common/z/zframe.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    // ##############################################################################################################

    export let personId: string

    let users: User[] = []
    let show = false
    let notes: Note[] = []
    let note: Note = new Note()

    async function loadEntities() {
        try {
            show = true
            notes = await window.api.events.notes(personId).getAll({ personId })
            users = await window.api.users.companies.getCompanyUsers()
            for (let note of notes) {
                note.user = users.find((el) => el.userId === note.userId)
            }
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function createNote() {
        try {
            if (show) return
            show = true
            const store: Store = new Store()
            let dto: CreateNoteDto = {
                content: note.content,
                personId,
                userId: store.token.userId,
            }
            await await window.api.events.notes(personId).create(dto)
            await loadEntities()
            note = new Note()
        } catch (error) {
            window.error(error)
        }
    }

    async function removeEntity(id) {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.events.notes(personId).remove(id)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    onMount(async () => {
        await loadEntities()
    })
</script>

<Zframe title="Notas">
    {#if !show}
        {#if notes.length === 0}
            <div class="text-muted mt-4 text-center">
                Nenhuma anotação.<br />Para fazer uma anotação utilize o campo abaixo.
            </div>
        {:else}
            <div class="items">
                {#each notes as item}
                    <div class="baloon">
                        <div class="baloon_content">{@html item.content.replaceAll('\n', '<br />')}</div>
                        <div class="footer">
                            <div class="from">
                                {item.user?.userName || ''} em {dayjs(item.createdAt).format('DD/MM/YYYY HH:mm')}
                            </div>
                            <div class="spacer" />
                            <button class="btn btn-link p-0" on:click={() => removeEntity(item.notesId)}>Excluir</button>
                        </div>
                    </div>
                {/each}
            </div>
        {/if}
    {/if}
    <div class="row new">
        <div class="input-group">
            <textarea rows="4" autocomplete="off" bind:value={note.content} class="form-control" />
            <button class="btn btn-primary" on:click={createNote}>Salvar</button>
        </div>
    </div>
</Zframe>
<LoadSpinner {show} delay={0}></LoadSpinner>

<style>
    .box {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .items {
        display: flex;
        flex-direction: column-reverse;
        align-items: stretch;
    }
    .baloon {
        border: 1px solid #99999920;
        padding: 4px;
        border-radius: 6px;
        background: #99999930;
        margin: 4px 0px;
        box-shadow: 1px 1px 2px #22222260;
        flex-grow: 1;
    }
    .footer {
        font-weight: 300;
        opacity: 0.75;
        display: flex;
        margin-top: 8px;
    }
    .footer * {
        font-size: 12px;
    }
    .new {
        margin-top: 24px;
    }
</style>
